"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1971],{

/***/ 71025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CollaborationWithComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.scss.js


var _defaultExport = new String(".collaboration-with-component.jsx-cab28dc4592febf5{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:-webkit-calc(.875rem + .6vw);font-size:-moz-calc(.875rem + .6vw);font-size:calc(.875rem + .6vw);-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-top:24px;.collaboration-with-text.jsx-cab28dc4592febf5{font-weight:400}.collaboration-with-image-wrapper.jsx-cab28dc4592febf5{margin-left:16px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;.collaboration-with-image.jsx-cab28dc4592febf5{max-height:2vw;min-height:32px}}}@media(max-width:".concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.collaboration-with-component.jsx-cab28dc4592febf5{font-size:-webkit-calc(.875rem + 1vw);font-size:-moz-calc(.875rem + 1vw);font-size:calc(.875rem + 1vw);.collaboration-with-image-wrapper.jsx-cab28dc4592febf5{.collaboration-with-image.jsx-cab28dc4592febf5{max-height:4vw;min-height:2vw}}}}"));
_defaultExport.__hash = "cab28dc4592febf5";
/* harmony default export */ var collaboration_with_component_scss = (_defaultExport);

// EXTERNAL MODULE: ./services/community/url-service.js
var url_service = __webpack_require__(932);
;// CONCATENATED MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.js










var CollaborationWithComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CollaborationWithComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CollaborationWithComponent);
    function CollaborationWithComponent() {
        (0,_class_call_check/* default */.Z)(this, CollaborationWithComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CollaborationWithComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, imageUrl = _props.imageUrl, color = _props.color, text = _props.text;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        color: colors/* default */.Z[color]
                    },
                    className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-text",
                            children: text
                        }),
                        imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,url_service.fixDevImageUrl)(imageUrl),
                                className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-image"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: collaboration_with_component_scss.__hash,
                            children: collaboration_with_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return CollaborationWithComponent;
}(react.PureComponent);

CollaborationWithComponent.defaultProps = {
    color: "black",
    text: "Powered By"
};


/***/ }),

/***/ 57858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextPartComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./services/onelink-service.js



var ONELINK_BASE_URL = "https://go.onelink.me/wwJQ";
var getOnelinkWithTrackingParams = function() {
    var url = window.location;
    var finalUrl = ONELINK_BASE_URL;
    // Parse URI, get query string hash
    var queryString = (0,utils_url.getQueryStringAsHash)(url);
    var m_source = queryString.marketing_source || queryString.utm_source;
    var m_banner = queryString.marketing_banner || queryString.utm_banner;
    var visitorId = (0,cookies_service/* getCookie */.ej)(constants_cookies.BIG_BRAIN_VISITOR_ID);
    // Indicate that the origin is mobile web.
    finalUrl += "?is_mobile_web=true";
    // Add source if given.
    if (m_source) {
        finalUrl += "&pid=".concat(m_source);
    }
    // Add banner if given.
    if (m_banner) {
        finalUrl += "&c=".concat(m_banner);
    }
    if (visitorId) {
        finalUrl += "&visitor_id=".concat(visitorId);
    }
    return finalUrl;
};

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.js + 1 modules
var collaboration_with_component = __webpack_require__(71025);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
;// CONCATENATED MODULE: ./services/platform-api-service.js
function platform_api_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            platform_api_service_define_property(target, key, source[key]);
        });
    }
    return target;
}
var URL_BASE = "https://auth.monday.com";
var DEFAULT_FETCH_OPTIONS = {
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
};
var baseFetch = function(url, options) {
    return fetch(url, _object_spread({}, DEFAULT_FETCH_OPTIONS, options));
};
var sendCookies = function(visitorId, cookies) {
    return baseFetch("".concat(URL_BASE, "/set_visitor_cookies"), {
        method: "POST",
        body: JSON.stringify({
            visitor_id: visitorId,
            cookies: cookies
        })
    });
};

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.scss.js


var _defaultExport = new String(".text-part-component.jsx-5ddbce48fc0d5d15{margin:16px 0;padding:0px 8px;text-align:center;.title-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:16px;.title-line.jsx-5ddbce48fc0d5d15{font-size:1.575rem;line-height:32px;display:block}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:54px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:1.125rem;line-height:8px;display:block}}.mobile-download-button-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:20px;.mobile-download-button{width:100%}}&.big-text.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{font-size:6vw;line-height:7vw}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:3vw;line-height:2vw}}}&.mobile-only.jsx-5ddbce48fc0d5d15{&.big-text.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{font-size:8vw;line-height:10vw}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{.subtitle-line.jsx-5ddbce48fc0d5d15{margin-bottom:16px}}&.mobile-clean-look.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{display:block;font-size:8vw;line-height:9vw;font-weight:500;padding-left:10%;padding-right:10%;margin-bottom:0;&.first.jsx-5ddbce48fc0d5d15{line-height:10vw}}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}.mobile-download-button-wrapper.jsx-5ddbce48fc0d5d15{.mobile-download-button{width:70%;min-width:220px;background-color:".concat(colors/* default.brand-blue */.Z["brand-blue"], "}}}}}@media(max-width:").concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.text-part-component.jsx-5ddbce48fc0d5d15{&.big-text.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{font-size:8vw;line-height:10vw}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.mobile-clean-look.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{display:block;font-size:8vw;line-height:9vw;font-weight:500;padding-left:10%;padding-right:10%;margin-bottom:0}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}.mobile-download-button-wrapper.jsx-5ddbce48fc0d5d15{.mobile-download-button{width:70%;min-width:220px;background-color:").concat(colors/* default.brand-blue */.Z["brand-blue"], "}}}}"));
_defaultExport.__hash = "5ddbce48fc0d5d15";
/* harmony default export */ var text_part_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function text_part_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}














var TextPartComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextPartComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextPartComponent);
    function TextPartComponent() {
        (0,_class_call_check/* default */.Z)(this, TextPartComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TextPartComponent, [
        {
            key: "shouldRenderSubtitle",
            value: function shouldRenderSubtitle() {
                var mobileTitleLines = this.props.mobileTitleLines;
                return mobileTitleLines.length < 3;
            }
        },
        {
            key: "onDownloadLinkClicked",
            value: function onDownloadLinkClicked(e) {
                // Send cookies to the server.
                var visitorId = (0,cookies_service/* getCookie */.ej)(constants_cookies.BIG_BRAIN_VISITOR_ID);
                if (visitorId) {
                    var cookies = (0,cookies_service/* getAllCookies */.RV)();
                    sendCookies(visitorId, cookies);
                }
                BigBrain("track", bigbrain_event_types.MOBILE_DOWNLOAD_LINK_CLICK);
                window.open(getOnelinkWithTrackingParams());
            }
        },
        {
            key: "removeBoldTagForText",
            value: function removeBoldTagForText(text) {
                return text ? text.replace(/<b>/g, "").replace(/<\/b>/g, "") : "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, mobileTitleLines = _props.mobileTitleLines, mobileSubtitleLines = _props.mobileSubtitleLines, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith, customStyle = _props.customStyle, color = _props.color, isMobileCleanLook = _props.isMobileCleanLook, isMobileOnly = _props.isMobileOnly;
                var _obj;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + (classnames_default()("text-part-component", (_obj = {}, (0,_define_property/* default */.Z)(_obj, customStyle, !!customStyle), (0,_define_property/* default */.Z)(_obj, "mobile-only", isMobileOnly), _obj)) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "title-lines-wrapper",
                            children: mobileTitleLines.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: colors/* default */.Z[color]
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: isMobileCleanLook ? _this.removeBoldTagForText(line) : line
                                    },
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + (classnames_default()("title-line", {
                                        first: index == 0
                                    }) || "")
                                }, index);
                            })
                        }),
                        this.shouldRenderSubtitle() && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "subtitle-lines-wrapper",
                            children: mobileSubtitleLines.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: colors/* default */.Z[color]
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: line
                                    },
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + "subtitle-line"
                                }, index);
                            })
                        }),
                        signupForm.showDownloadButtonOnMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "mobile-download-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                                className: "mobile-download-button",
                                color: signupForm.buttonColor,
                                onClickCallback: this.onDownloadLinkClicked,
                                children: signupForm.downloadButtonTitle
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "signup-form-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: signupForm.inputPlaceholder,
                                ctaText: signupForm.buttonText,
                                useCtaText: !!signupForm.buttonText,
                                buttonColor: signupForm.buttonColor
                            })
                        }),
                        collaborationWith.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(collaboration_with_component/* default */.Z, text_part_component_object_spread({}, collaborationWith)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: text_part_component_scss.__hash,
                            children: text_part_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return TextPartComponent;
}(react.PureComponent);

TextPartComponent.defaultProps = {
    mobileTitleLines: [],
    mobileSubtitleLines: []
};


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ })

}]);